import { render, staticRenderFns } from "./LeadManager.vue?vue&type=template&id=2df22ec5&"
import script from "./LeadManager.vue?vue&type=script&lang=js&"
export * from "./LeadManager.vue?vue&type=script&lang=js&"
import style0 from "./LeadManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports